import Vue from "vue";
import VueI18n from "vue-i18n";

import elementZhLocale from "element-ui/lib/locale/lang/zh-CN";
import elementEnLocale from "element-ui/lib/locale/lang/en";
import elementJaLocale from "element-ui/lib/locale/lang/ja";
import zhLocale from "./zh.json";
import enLocale from "./en.json";
import jaLocale from "./ja.json";
import { langFlag } from "../config/project";

Vue.use(VueI18n);

export const VALID_LANGS = ["zh", "en", "ja"];
const GUESSED_FLAG = "locale-guessed";

const messages = {
  zh: { ...elementZhLocale, ...zhLocale },
  en: { ...elementEnLocale, ...enLocale },
  ja: { ...elementJaLocale, ...jaLocale },
};

// 语言决策优先级：URL ?locale= > localStorage > 浏览器推断 > en
export function getLanguage() {
  const url = new URLSearchParams(location.search).get("locale");
  if (VALID_LANGS.includes(url)) {
    localStorage.setItem(langFlag, url);
    localStorage.removeItem(GUESSED_FLAG); // 显式选择，清除推断标记
    const u = new URL(location.href);
    u.searchParams.delete("locale");
    history.replaceState(null, "", u.toString());
    return url;
  }
  const saved = localStorage.getItem(langFlag);
  if (VALID_LANGS.includes(saved)) return saved;
  const nav = (navigator.language || "en").slice(0, 2).toLowerCase();
  const guess = nav === "zh" ? "zh" : nav === "ja" ? "ja" : "en";
  localStorage.setItem(langFlag, guess);
  localStorage.setItem(GUESSED_FLAG, "1"); // 打推断标记，登录后可被 DB 覆盖
  return guess;
}

export function isGuessedLocale() {
  return localStorage.getItem(GUESSED_FLAG) === "1";
}

export function clearGuessedLocale() {
  localStorage.removeItem(GUESSED_FLAG);
}

export { langFlag, GUESSED_FLAG };

const i18n = new VueI18n({
  locale: getLanguage(),
  fallbackLocale: "en",
  silentTranslationWarn: true,
  messages,
});

export function routeTitle(route) {
  // Main 是路由生成器追加的布局后缀，不是另一组业务词条
  const name = String(route.name || "").replace(/Main$/, "");
  const key = `routes.${name}`;
  return i18n.te(key) ? i18n.t(key) : (route.meta && route.meta.title) || i18n.t("nav.platform_name");
}

export default i18n;
